import { Injectable } from '@angular/core';
import { isNil } from 'lodash';
import { Nullable } from 'primeng/ts-helpers';
import { LatLonLocation } from '../../../contract/lat-lon-location.contract';
import { LatLon } from '../../../contract/lat-lon.contract';

@Injectable({ providedIn: 'root' })
export class MapUtilsService {
  public isValidLocation(value: LatLonLocation): boolean {
    return Boolean(
      value?.location &&
      this.isValidLatLon(value.location)
    );
  }

  public isValidLatLon(value: LatLon): boolean {
    return Boolean(
      value &&
      Number.isFinite(value.lat) && Math.abs(value.lat) <= 90 &&
      Number.isFinite(value.lon) && Math.abs(value.lon) <= 180
    );
  }

  public locationToLatLngLiteral(location: LatLon | Nullable): google.maps.LatLngLiteral | null {
    return !(isNil(location?.lat) || isNil(location?.lon))
      ? { lat: location.lat, lng: location.lon }
      : null;
  }
}
